<template>
  <div class="grid-view__group" v-bind="$attrs">
    <div class="grid-view__group-cell">
      <button
        type="button"
        class="grid-view__group-toggle"
        @click="$emit('toggle')"
      >
        <i
          class="grid-view__group-marker iconoir-nav-arrow-down"
          :class="{ 'grid-view__group-marker--collapsed': collapsed }"
        ></i>
        <span class="grid-view__group-name">{{ field?.name }}</span>
        <div class="grid-view__group-value">
          <component
            :is="groupByComponent"
            v-if="groupByComponent"
            :field="field"
            :value="value"
          />
        </div>
        <span v-if="count > 0" class="grid-view__group-count">
          {{ count }}
        </span>
      </button>
      <button
        v-if="canAdd"
        type="button"
        class="grid-view__group-add"
        :aria-label="$t('gridViewSubtasks.addRowToGroup')"
        @click.stop="$emit('add-row')"
      >
        <i class="iconoir-plus"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GridViewGroup',
  emits: ['toggle', 'add-row'],
  props: {
    groupBy: {
      type: Object,
      required: true,
    },
    allFieldsInTable: {
      type: Array,
      required: true,
    },
    value: {
      type: null,
      required: true,
    },
    count: {
      type: Number,
      required: true,
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
    canAdd: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    field() {
      return this.getField(this.allFieldsInTable, this.groupBy)
    },
    groupByComponent() {
      if (!this.field) {
        return null
      }
      return this.getGroupByComponent(this.field, this)
    },
  },
  methods: {
    getField(allFieldsInTable, groupBy) {
      const field = allFieldsInTable.find((f) => f.id === groupBy.field)
      return field
    },
    getGroupByComponent(field, parent) {
      const fieldType = parent.$registry.get('field', field.type)
      return fieldType.getGroupByComponent(field)
    },
  },
}
</script>
